module.exports = "/_next/static/images/InaccurateData-1904bb7c9c4427ae87bd5a359fcf4c98.png";